import ImageAndText from './ImageAndText';
export default ImageAndText;
